import type { NamespaceSchema } from './types';

// Global pricing knobs. Read by apps/api pricing/config.ts loadPricingSettings()
// from the 'pricing-settings' platform-config namespace. Values are FRACTIONS
// (0.01 = 1%). Per-crew overrides on each crew (Crew detail page) take precedence.

export const pricingSettings: NamespaceSchema = {
  namespace: 'pricing-settings',
  label: 'Pricing',
  description:
    'What we ADD ON TOP of a crew\'s price — the customer pays it, folded into one inclusive figure. Not the same as commission, which is deducted from what the crew earns and lives under Vendor / host. Values are FRACTIONS (0.20 = 20%). A crew or a B2B partner can override these on its own detail page.',
  sections: [
    {
      label: 'Global pricing',
      fields: [
        { kind: 'number', key: 'globalMarkupPct', label: 'Extra markup on car listings (fraction: 0.01 = 1%)', default: 0.01, min: 0, step: 0.01 },
        { kind: 'number', key: 'platformPct', label: 'Platform fee added to every price (fraction: 0.20 = 20%)', default: 0.2, min: 0, step: 0.01 },
        { kind: 'number', key: 'pickupBufferPct', label: 'Pickup-pin buffer (fraction: 0.01 = 1%)', default: 0.01, min: 0, step: 0.01 },
      ],
    },
  ],
};
